var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"20ce3ab3b4f7613d346d3a896b702de647d6fcc0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["ambii-patient@ambii-tw"]={id:"20ce3ab3b4f7613d346d3a896b702de647d6fcc0"};
      